import { connect } from 'react-redux';
import en from '../../lang/en-us';
import { RootStateType } from '../../redux-store/reducers';
import { maskMobileNumber } from '../../utils/utilityFunctions';

const { dashboard } = en;

interface TextWrapperProps {
    userRegisteredWith?: string;
    mobile?: string;
    email?: string;
    _mobile?: string;
    _email?: string;
}

const OtpSentTextWrapper = (props: TextWrapperProps) => {
    const { userRegisteredWith = 'MOBILE', _mobile, _email } = props;
    return !!_mobile || userRegisteredWith === 'MOBILE' ? (
        <p>
            {dashboard.OtpScreen.otpPhoneSubject}{' '}
            <span>{maskMobileNumber(_mobile || props?.mobile || '')}</span>
        </p>
    ) : (
        <p>
            {dashboard.OtpScreen.subHeadingInfo} <span>{_email || props.email}</span>
        </p>
    );
};

export default connect(
    ({ authReducer }: RootStateType) => ({ ...authReducer }),
    null,
)(OtpSentTextWrapper);
